export type DrawdownInput = {
  accountSizeUsd: number;
  maxDrawdownPct: number;
  dailyDrawdownPct: number | null;
};

export type DrawdownOutput = {
  maxDrawdownUsd: number;
  dailyDrawdownUsd: number | null;
  breakEvenStreakLossPct: number; // % loss that wipes max DD
  riskBudgetAt1Pct: number; // number of 1% losses you survive before breaching max DD
};

export function calcDrawdown(input: DrawdownInput): DrawdownOutput {
  const maxUsd = (input.accountSizeUsd * input.maxDrawdownPct) / 100;
  const dailyUsd =
    input.dailyDrawdownPct == null ? null : (input.accountSizeUsd * input.dailyDrawdownPct) / 100;
  return {
    maxDrawdownUsd: maxUsd,
    dailyDrawdownUsd: dailyUsd,
    breakEvenStreakLossPct: input.maxDrawdownPct,
    riskBudgetAt1Pct: Math.floor(input.maxDrawdownPct / 1),
  };
}
